import VacancyIndex from "../views/VacancyIndex.vue";
import ApplicantCard from "../views/ApplicantCard.vue";
import VacancyCard from "../views/VacancyCard.vue";
import vacancyWrapper from "@/modules/vacancy/components/vacancyWrapper";

export const routes = [
  {
    path: "/vacancies",
    name: "vacancyWrapper",
    component: vacancyWrapper,
    children: [
      {
        path: "/vacancies",
        name: "VacancyIndex",
        component: VacancyIndex
      },
      {
        path: "/:action/:id",
        name: "cardVacancy",
        component: VacancyCard
      },
      {
        path: "/vacancy/:action/:id",
        name: "cardVacancy",
        component: VacancyCard
      },
      {
        path: "/applicant/:action/:id",
        name: "cardApplicant",
        component: ApplicantCard
      }
    ]
  }
];
